<!-- 卡片预览 -->
<template>
  <div class="CardPreview">
    <div class="head">
      <label>请查看并确认您的个性卡正面和背面</label>
    </div>
    <div class="main">
      <div class="main_title">
        <div class="cardOriGroup">
          <div>
            <input
              id="ori_h"
              type="radio"
              v-model="cardOri"
              name="cardOriRd"
              value="0"
            />
            <label for="ori_h">正面</label>
          </div>
          <div>
            <input
              id="ori_v"
              type="radio"
              v-model="cardOri"
              name="cardOriRd"
              value="1"
            />
            <label for="ori_v">背面</label>
          </div>
        </div>
      </div>
      <div class="main_image" v-if="ifImage_zheng">
        <div class="main_image_heng" v-if="heng">
          <img
            src="../../../static//hunanDIY/组横.png"
            style="position: absolute; width: 340px; height: 214px"
          />
          <img class="imge" :src="imgPath" />
        </div>
        <div class="main_image_shu" v-if="shu">
          <img
            src="../../../static/hunanDIY/组竖.png"
            style="position: absolute; width: 214px; height: 340px"
          />
          <img class="imge" :src="imgPath" />
        </div>
      </div>
      <div class="main_image" v-if="ifImage_fan">
        <img src="../../../static/hunanDIY/湖南银行照片反面.png" />
      </div>
      <div class="main_image" v-if="ifImage_fan_heng">
        <img src="../../../static/hunanDIY/湖南银行照片反面横版.png" />
      </div>
      <div class="main_tips">
        <div class="main_tips_head">
          <label>高清彩绘喷印工艺，高保真还原您的卡片</label>
        </div>
        <div class="main_tips_miaoshu">
          <label>卡面预览仅供参考，具体以实际卡面为准</label>
          <label>（该卡制作时间约为10-15个工作日）</label>
        </div>
      </div>
    </div>
    <div class="foot">
      <b-button
        variant="danger"
        @click="nextOperation()"
        style="width: 290px; height: 46px; border-radius: 10px"
        >下一步</b-button
      >
    </div>
    <!-- loading toast  提交中-->
    <div v-show="loading">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-loading weui-icon_toast"></i>
        <p class="weui-toast__content">图片上传中</p>
      </div>
    </div>
    <b-modal
      ref="model_image_AI"
      title="提示"
      @ok="handleBankConfirm"
      ok-title="确定"
      cancel-title="取消"
    >
      <p>您上传的照片审核未通过，请重新上传。</p>
    </b-modal>
  </div>
</template>
<script>
import wx from "weixin-js-sdk";
import axios from "axios";
var config = require("../../common/config.js");
export default {
  name: "CardPreview",
  data() {
    return {
      cardOri: 0,
      ifImage_zheng: true,
      ifImage_fan: false,
      ifImage_fan_heng: false,
      imgPath: "",
      imgPath_logo: "",
      heng: null,
      shu: null,
      base64: "",
      bankCode: "0035",
      bankSerialNumber: "",
      cardTechnology: "",
      orderNo: "",
      modifyPicture: "", //是否为修改图片（1：申请，2：修改）
      horizontalAndVerticalSign: "", //横竖屏标识 （1：竖屏 2 ：横屏）
      loading: false,
    };
  },
  watch: {
    cardOri: function (newval, oldval) {
      if (newval == 0) {
        if (this.horizontalAndVerticalSign == 1) {
          this.ifImage_fan = false;
        } else {
          this.ifImage_fan_heng = false;
        }
        this.ifImage_zheng = true;
      } else if (newval == 1) {
        if (this.horizontalAndVerticalSign == 1) {
          this.ifImage_fan = true;
        } else if (this.horizontalAndVerticalSign == 2) {
          this.ifImage_fan_heng = true;
        }
        this.ifImage_zheng = false;
      }
    },
  },
  methods: {
    // 弹窗确定接口
    handleBankConfirm: function () {
      // 确定之后重新上传
      let query = {
        modifyPicture: this.modifyPicture,
        bankSerialNumber: this.bankSerialNumber,
      };
      this.$router.push({
        name: "Agreement",
        query: query,
      });
    },
    showBankConfirm: function () {
      this.$refs["model_image_AI"].show();
    },
    // 加载弹窗
    showLoading: function () {
      this.loading = true;
    },
    hideLoading: function () {
      this.loading = false;
    },
    // 下一步
    nextOperation() {
      this.showLoading();
      this.click();
    },
    isOrder() {
      if (this.modifyPicture == 1) {
        console.log("申请图片");
        this.submitOrder();
      } else if (this.modifyPicture == 2) {
        console.log("修改图片");
        this.queryOrder();
      }
    },
    // 查询订单接口
    queryOrder() {
      let that = this;
      let params = {
        bankCodeModel: {
          bankCode: "0035",
          serialList: [this.bankSerialNumber],
        },
        pageIndex: 1,
        pageSize: 1,
      };
      console.log("params--->", params);
      axios.post(config.config_hunan.queryOrder, params).then((res) => {
        let data = res.data;
        console.log("res--->", res);
        if (data.code == 0) {
          console.log(
            "data.orderModelList.orderNo--->",
            data.orderModelList[0].orderNo
          );
          that.orderNo = data.orderModelList[0].orderNo;
          if (data.orderModelList[0].orderStatsNo == 3) {
            that.showBankConfirm();
          } else if (data.orderModelList[0].orderStatsNo == 1) {
            that.modify();
          }
        } else {
          // AI审核不通过
          that.showBankConfirm();
        }
      });
    },
    // 修改接口
    modify() {
      var facademd5 = this.$md5(this.imgPath);
      if (this.heng == true) {
        this.cardTechnology = 0;
      } else {
        this.cardTechnology = 1;
      }
      var myObj = {
        orderNo: this.orderNo, //订单编号
        backgroupColor: 4,
        cardTypography: this.horizontalAndVerticalSign == 1 ? 1 : 0, //横版：0 ，竖版：1
        cardTechnology: this.cardTechnology,
        facadeImage: this.imgPath,
        facademd5: facademd5,
        audit: true, //下单时，是否进行AI审核, true 审核, false 不审核
      };
      console.log("myObj--->", myObj);
      axios.post(config.config_hunan.modify, myObj).then((res) => {
        console.log("res--->", res);
        let data = res.data;
        // -----------------------------下完单之后进行AI审核-----------------------------
        // 保存图片跳转小程序
        this.toDataBase64();
        // if (data.code == 0 ) {
        //   this.toDataBase64();
        // } else if (data.code == 2001) {
        //   // this.toDataBase64();
        //   console.log("AI审核通过，不允许修改此订单");
        // }
      });
    },
    // 下单接口
    submitOrder() {
      let that = this;
      var facademd5 = this.$md5(this.imgPath);
      if (this.heng == true) {
        this.cardTechnology = 0;
      } else {
        this.cardTechnology = 1;
      }
      var myObj = {
        bankSerialNumber: this.bankSerialNumber,
        cardType: 1,
        cardTechnology: this.cardTechnology,
        cardTypography: this.horizontalAndVerticalSign == 1 ? 1 : 0, //横版：0 ，竖版：1
        backgroupColor: 4,
        cardSubject: "99",
        bankCode: this.bankCode,
        facadeImage: this.imgPath,
        facademd5: facademd5,
        audit: true, //下单时，是否进行AI审核, true 审核, false 不审核
      };
      // var myObj = {
      //   bankSerialNumber: this.bankSerialNumber,  //银行唯一号
      //   cardType: 1,
      //   cardTechnology: "",  //横竖版  横0 竖1
      //   cardTypography: 2,   //工艺类型
      //   backgroupColor: 4,   //背景颜色 ：白色
      //   cardSubject: "99",   //默认主题
      //   bankCode: this.bankCode,
      //   facadeImage: this.base64,
      //   facademd5: facademd5,
      //   audit: true
      // };
      console.log("myObj--->", myObj);
      axios({
        method: "post",
        url: config.config_hunan.submitOrder,
        data: myObj,
      }).then((res) => {
        console.log("res--->", res);
        let data = res.data;
        // 保存图片保存小程序
        this.orderNo = data.orderNo;
        // -----------------------------下完单之后进行AI审核-----------------------------
        that.submitQueryOrder();
        // that.toDataBase64();
        // if (data.code == 0) {
        //   this.orderNo = data.orderNo;
        //   this.toDataBase64();
        // } else if (data.code == 2001) {
        //   // this.orderNo = data.orderNo;
        //   // this.toDataBase64();
        // }
      });
    },
    submitQueryOrder() {
      let that = this;
      let params = {
        bankCodeModel: {
          bankCode: "0035",
          serialList: [this.bankSerialNumber],
        },
        pageIndex: 1,
        pageSize: 1,
      };
      axios.post(config.config_hunan.queryOrder, params).then((res) => {
        let data = res.data;
        console.log("res------------------------>", res);
        if (data.code == 0) {
          if (data.orderModelList[0].orderStatsNo == 3) {
            this.hideLoading();
            that.showBankConfirm();
          } else if (data.orderModelList[0].orderStatsNo == 1) {
            that.toDataBase64();
          } else {
            // 延时5秒
            setTimeout(() => {
              that.submitQueryOrder(); // 注意这里没有括号，表示调用函数本身
            }, 2000);
          }
        } else {
          // AI审核不通过
          // that.showBankConfirm();
        }
      });
    },

    // 贴上log
    click() {
      if (this.shu == true) {
        let list = [this.imgPath_logo, "../../../static/hunanDIY/组竖.png"];
        this.mergeImgs(list);
      } else if (this.heng == true) {
        let list = [this.imgPath_logo, "../../../static/hunanDIY/组横.png"];
        this.mergeImgs(list);
      }
    },
    // 拼接图片贴上logo
    mergeImgs(list) {
      let that = this;
      if (this.shu == true) {
        var cwith = 214;
        var cheight = 340;
      } else if (this.heng == true) {
        var cwith = 340;
        var cheight = 214;
      }
      return new Promise((resolve, reject) => {
        const baseList = [];
        // 创建 canvas 节点并初始化
        const canvas = document.createElement("canvas");
        canvas.width = cwith;
        canvas.height = cheight;
        const context = canvas.getContext("2d");
        list.map((item, index) => {
          const img = new Image();
          img.src = item;
          // 跨域
          img.crossOrigin = "Anonymous";
          img.onload = () => {
            context.drawImage(img, 0, 0);
            const base64 = canvas.toDataURL("image/png");
            baseList.push(base64);
            if (baseList[list.length - 1]) {
              console.log("baseList--->", baseList);
              // 返回新的图片
              resolve(baseList[list.length - 1]);
              that.base64 = baseList[list.length - 1];
              console.log("that.base64--->", that.base64);
              if (that.base64 == "") {
                console.log("请重新上传图片");
              } else {
                that.isOrder();
              }
            }
          };
        });
      });
    },
    toDataBase64() {
      let param = {
        base64File: this.base64,
        orderNo: this.orderNo,
      };
      console.log("上传");
      axios.post(config.config_hunan.uploadFile, param).then((res) => {
        let data = res.data;
        if (data.code == 200) {
          this.goTo_wx();
          console.log("跳转小程序");
        } else {
          console.log("图片未上传成功");
        }
      });
    },
    // 判断是否修改图片
    goTo_wx() {
      if (this.modifyPicture == 1) {
        console.log("申请图片--跳转小程序");
        this.toWX_hunanBank();
      } else if (this.modifyPicture == 2) {
        console.log("修改图片--跳转小程序");
        this.toWX_hunanBank_xiugai();
      }
    },
    // 跳转银行小程序页面
    toWX_hunanBank() {
      let params = {
        imgbase64: this.base64, // 携带logo的图片base64格式
        PhotoID: this.bankSerialNumber, //银行唯一流水号
        horizontalAndVerticalSign: this.horizontalAndVerticalSign, //横竖屏标识
      };
      console.log("跳转小程序传输参数------>", params);
      wx.miniProgram.postMessage({
        data: params,
      });
      // wx.miniProgram.redirectTo({ url: "/card/pages/front/index" });
      //微信跳转4月13日上线不提交
      wx.miniProgram.navigateBack({
        delta: 1,
      });
      this.hideLoading();
    },
    // 修改图片跳转银行小程序接口
    toWX_hunanBank_xiugai() {
      let params = {
        imgbase64: this.base64, // 携带logo的图片base64格式
        PhotoID: this.bankSerialNumber, //银行唯一流水号
        horizontalAndVerticalSign: this.horizontalAndVerticalSign, //横竖屏标识
      };
      console.log("跳转小程序传输参数------>", params);
      wx.miniProgram.postMessage({
        data: params,
      });
      wx.miniProgram.redirectTo({ url: "/card/pages/additional/index" });
      //微信跳转4月13日上线不提交
      // wx.miniProgram.navigateBack({
      //   delta: 1,
      // });
      this.hideLoading();
    },
  },

  mounted: function () {
    this.imgPath = this.$route.params.targetImg;
    this.imgPath_logo = this.$route.params.targetImg_logo;
    console.log("this.imgPath--->", this.imgPath);
    this.heng = this.$route.params.hengPath;
    this.shu = this.$route.params.shuPath;
    // 判断是否横竖屏
    if (this.shu == true) {
      this.horizontalAndVerticalSign = 1;
    } else if (this.heng == true) {
      this.horizontalAndVerticalSign = 2;
    }
    this.bankSerialNumber = this.$route.params.bankSerialNumber;
    console.log("bankSerialNumber:" + this.bankSerialNumber);
    if (this.bankSerialNumber !== undefined) {
      sessionStorage.setItem("bankSerialNumber", this.bankSerialNumber);
    } else {
      this.bankSerialNumber = sessionStorage.getItem("bankSerialNumber");
    }
    this.modifyPicture = this.$route.params.modifyPicture;
    console.log("modifyPicture:" + this.modifyPicture);
    if (this.modifyPicture !== undefined) {
      sessionStorage.setItem("modifyPicture", this.modifyPicture);
    } else {
      this.modifyPicture = sessionStorage.getItem("modifyPicture");
    }
  },
};
</script>
<style scoped>
.CardPreview {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.head {
  font-size: 16px;
  font-weight: 700;
  padding: 41px 0 0;
}
.cardOriGroup {
  display: flex;
  flex-direction: row;
  justify-content: center;
  text-align: center;
  align-items: flex-end;
  height: 64px;
}
.cardOriGroup input {
  display: none;
}
.cardOriGroup label {
  color: gray;
  line-height: 28px;
  min-width: 20px;
  min-height: 28px;
  text-align: center;
  border-radius: 4px;
  margin: 8px;
}
.cardOriGroup input:checked + label {
  background-size: 21px 21px;
  color: red;
  margin: 8px;
}
.main {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.main_image {
  width: 340px;
  height: 340px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.main_image_heng {
  border-radius: 10px;
  width: 340px;
  height: 214px;
}
.main_image_shu {
  border-radius: 10px;

  width: 214px;
  height: 340px;
}
.imge {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.main_tips {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.main_tips_head {
  font-size: 15px;
  font-weight: 700;
}
.main_tips_miaoshu {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  font-size: 14px;
  color: #999999;
}
.foot {
  padding-top: 56px;
}
</style>



// WEBPACK FOOTER //
// src/components/hunanbank/CardPreview.vue